<div class="flex flex-col gap-6 flex-1 min-h-0 w-full h-full">
  @if (groupedEvents().length === 0) {
    <!-- État vide -->
    <div
      class="flex flex-col items-center justify-center p-12 text-center border border-dashed border-neutral-5 rounded-2xl bg-neutral-2/40"
    >
      <div class="w-12 h-12 rounded-full bg-neutral-3 flex items-center justify-center text-neutral-10 mb-3">
        <mat-icon class="!text-2xl !w-6 !h-6 flex items-center justify-center">event_busy</mat-icon>
      </div>
      <h3 class="text-base font-semibold text-neutral-12 mb-1">Aucun rendez-vous</h3>
      <p class="text-sm text-neutral-10 max-w-sm">
        {{ emptyMessage() }}
      </p>
    </div>
  } @else {
    <!-- Liste chronologique groupée par jour -->
    @for (group of groupedEvents(); track group.dateLabel) {
      <div class="flex flex-col gap-3">
        <!-- En-tête du jour -->
        <div class="flex items-center gap-2 sticky top-0 z-10 bg-neutral-1/90 backdrop-blur-xs py-1.5">
          <span
            [class]="
              group.isToday
                ? 'bg-primary-9 text-white font-semibold'
                : 'bg-neutral-3 text-neutral-11 font-medium'
            "
            class="text-xs px-2.5 py-1 rounded-full shadow-2xs"
          >
            {{ group.dateLabel }}
          </span>
          <div class="h-px bg-neutral-4 flex-1"></div>
        </div>

        <!-- Cartes d'événements du jour -->
        <div class="grid grid-cols-1 gap-3">
          @for (evt of group.events; track evt.id) {
            <div
              role="button"
              tabindex="0"
              (click)="eventClick.emit(evt)"
              (keydown.enter)="eventClick.emit(evt)"
              [class]="getBorderColor(evt.category)"
              class="border border-neutral-4 border-l-4 rounded-xl p-4 bg-neutral-1 hover:bg-neutral-2/50 shadow-2xs hover:shadow-xs transition-all flex flex-col md:flex-row md:items-center justify-between gap-4 cursor-pointer"
            >
              <!-- Contenu principal -->
              <div class="flex flex-col gap-2 min-w-0 flex-1">
                <div class="flex items-center gap-2 flex-wrap">
                  @if (evt.sourceId === 'french-holidays') {
                    <span
                      class="text-[11px] font-medium px-2 py-0.5 rounded-full border bg-violet-3 text-violet-11 border-violet-6"
                    >
                      Jour férié
                    </span>
                  } @else if (evt.status) {
                    @let statusBadge = getStatusBadge(evt.status);
                    <span
                      [class]="statusBadge.class"
                      class="text-[11px] font-medium px-2 py-0.5 rounded-full border"
                    >
                      {{ statusBadge.label }}
                    </span>
                  }

                  <span class="inline-flex items-center gap-1 text-xs font-semibold text-neutral-11">
                    <mat-icon class="!text-sm !w-3.5 !h-3.5 flex items-center justify-center"
                      >schedule</mat-icon
                    >
                    {{ getTimeFormatted(evt) }}
                  </span>
                </div>

                <h4 class="text-base font-semibold text-neutral-12 tracking-tight m-0">
                  {{ evt.title }}
                </h4>

                @if (evt.description) {
                  <p class="text-xs text-neutral-11 line-clamp-2 m-0">
                    {{ evt.description }}
                  </p>
                }

                <!-- Informations complémentaires (lieu & participants) -->
                <div class="flex items-center gap-4 text-xs text-neutral-10 flex-wrap mt-0.5">
                  @if (evt.location?.address) {
                    <span class="inline-flex items-center gap-1">
                      <mat-icon class="!text-sm !w-3.5 !h-3.5 flex items-center justify-center text-neutral-9"
                        >place</mat-icon
                      >
                      <span class="truncate max-w-[280px]">{{ evt.location?.address }}</span>
                    </span>
                  }

                  @if (evt.attendees && evt.attendees.length > 0) {
                    <span class="inline-flex items-center gap-1">
                      <mat-icon class="!text-sm !w-3.5 !h-3.5 flex items-center justify-center text-neutral-9"
                        >group</mat-icon
                      >
                      <span>
                        {{ evt.attendees.length }} participant{{ evt.attendees.length > 1 ? 's' : '' }}
                      </span>
                    </span>
                  }
                </div>
              </div>

              <!-- Actions directes (Google, iCal, Détails) -->
              <div class="flex items-center gap-2 shrink-0 self-end md:self-center">
                <button
                  type="button"
                  (click)="eventClick.emit(evt)"
                  class="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-primary-11 hover:text-primary-12 bg-primary-2 hover:bg-primary-3 border border-primary-5 rounded-lg transition-colors cursor-pointer"
                >
                  Détails
                </button>
              </div>
            </div>
          }
        </div>
      </div>
    }
  }
</div>
